import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function () { return ({
    root: {
        minHeight: '600px',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center'
    },
    internalWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        width: '100%'
    },
    imageWrapper: {
        justifyContent: 'center',
        alignContent: 'center',
        display: 'flex'
    },
    messageWrapper: {
        marginTop: '16px',
        textAlign: 'center'
    }
}); });
function UserTableBlankBase(_a) {
    var image = _a.image, message = _a.message;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(Grid, { container: true, className: classes.internalWrapper },
            React.createElement(Grid, { item: true, xs: 12, className: classes.imageWrapper }, image),
            React.createElement(Grid, { className: classes.messageWrapper, item: true, xs: 12 }, message))));
}
export default UserTableBlankBase;
//# sourceMappingURL=UserTableBlankBase.js.map